import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Documentação</Title>

                    <section className="mt-2 p-3">

                        <p>
                            Axial P.M. utilizar ww 250 e wl 50;<br/>
                            Axial Osso utilizar ww 4500 e wl 500;<br/>
                            Coronal Osso utilizar ww 4.500 e wl 500;
                        </p>
                        <p>
                            <b>Axial P.M. direito C/C -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Axial P.M. esquerdo C/C -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Axial Osso direito -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Axial Osso esquerdo -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Coronal Osso direito -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Coronal Osso esquerdo -</b> 1 filme na formatação de 20 imagens;<br/>
                        </p>

                        <p>Sempre que utilizar o meio de contraste I.V. identificar no filme.</p>

                        <p>
                            <b>Impressão Mista, Filme e Papel</b><br/>
                            Axial em filme; <br/>
                            Coronal em papel;<br/>
                        </p>
                        <p>
                            <b>Impressão apenas em Papel</b><br/>
                            Axial em papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}